export default __webpack_public_path__ + "5e713d4f2f2d620e6c3928ca84fc34c6.webp";